<template>
  <div class="solution page-wrapper">
    <el-image
      class="banner"
      style="width: 100%;"
      :src="require('../../assets/sl_banner1.png')"
      fit="scale-down">
    </el-image>
    <div class="container">
      <div class="row">
        <el-row class="section1">
          <el-col :span="12" :xs="{ span: 24 }">
            <img src="../../assets/sl_image1.png" alt="">
          </el-col>
          <el-col :span="12" :xs="{ span: 24 }">
            <h2>智能照明解决方案</h2>
            大于智能照明方案, 一站式提供智能照明硬件方案、智能综合 App、家居照明 App、IoT智能云平台、及各类增值服务, 帮您赋能智能家居、商业照明、户外景观小品、工程项目等多种智能照明产品和场景方案。
          </el-col>
        </el-row>
        <hr class="section2"/>
        <h2 class="section3">智能家电</h2>
        <div class="section4">
          <!-- <img :src="`../../assets/icon-left.png`" alt=""> -->
          <el-row :gutter="0">
            <el-col :span="8" :xs="{ span: 24 }" class="link" @click.native="$router.push('/solution/air')">
              <img src="../../assets/sl_slider1.png" alt="">
              <span>空调智能化方案</span>
            </el-col>
            <el-col :span="8" :xs="{ span: 24 }">
              <img src="../../assets/sl_slider2.png" alt="">
              <span>吹风机智能化方案</span>
            </el-col>
            <el-col :span="8" :xs="{ span: 24 }">
              <img src="../../assets/sl_slider3.png" alt="">
              <span>温奶器智能化方案</span>
            </el-col>
          </el-row>
          <!-- <img :src="`../../assets/icon-right.png`" alt=""> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.section1 {
  margin: 40px 0;
  position: relative;
  .el-col {
    height: 100%;
    position: relative;
    img {
      width: 100%;
    }
  }
  .el-col:last-child {
    height: 350px;
    display: flex;
    align-items: center;
    line-height: 1.66;
    flex-direction: column;
    justify-content: center;
    h2 {
      margin: 0 0 40px;
    }
  }
}
.section2 {
  border-left: 0;
  border-right: 0;
  border-top: 0;
  border-bottom: 1px solid #DDD;
}
.section3 {
  text-align: center;
  margin: 100px 0 40px;
}
.section4 {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 160px;
  & > img {
    flex: 0 0 auto;
  }
  .el-row {
    flex: 1 1 auto;
    .el-col {
      position: relative;
      text-align: center;

      & span {
        position: absolute;
        bottom: 100px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
}
</style>